// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"29396952","147":"48198676","362":"c3af2f90","504":"8ba8001e","574":"6c85020d","807":"0e0dc2fb","815":"5be7d004","818":"f0e4c81d","900":"30817e25","959":"0fbadc52","996":"9c6ae4f4"}[chunkId] + ".chunk.js";
};